/**
 * Billing Close Page
 * Auto-closes the tab after Stripe redirects back
 * This prevents the Stripe success page from showing in the checkout tab
 */

import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export default function BillingClosePage() {
  const [searchParams] = useSearchParams();
  const status = searchParams.get('status');

  useEffect(() => {
    console.log('[BillingClosePage] Mounted with status:', status);

    // Try to close immediately and repeatedly
    const attemptClose = () => {
      console.log('[BillingClosePage] Attempting to close window...');
      window.close();
    };

    // Try multiple times in case first attempt fails
    attemptClose();
    const timer1 = setTimeout(attemptClose, 100);
    const timer2 = setTimeout(attemptClose, 300);
    const timer3 = setTimeout(attemptClose, 500);

    // Fallback: if window.close() doesn't work (some browsers block it),
    // show a message to the user after 1 second
    const fallbackTimer = setTimeout(() => {
      console.log('[BillingClosePage] window.close() failed, showing fallback UI');
      document.body.innerHTML = `
        <div style="display: flex; align-items: center; justify-content: center; height: 100vh; font-family: system-ui, -apple-system, sans-serif; text-align: center; padding: 20px;">
          <div>
            <h1 style="font-size: 24px; margin-bottom: 16px;">
              ${status === 'success' ? '✓ Payment Complete!' : 'Payment Canceled'}
            </h1>
            <p style="color: #666; margin-bottom: 20px;">
              You can close this tab now.
            </p>
            <button
              onclick="window.close()"
              style="background: #3b82f6; color: white; border: none; padding: 12px 24px; border-radius: 8px; cursor: pointer; font-size: 16px;"
            >
              Close Tab
            </button>
          </div>
        </div>
      `;
    }, 1000);

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
      clearTimeout(timer3);
      clearTimeout(fallbackTimer);
    };
  }, [status]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
        <p className="text-muted-foreground">Redirecting...</p>
      </div>
    </div>
  );
}
